import React, { useEffect, useState } from "react";
import "./project.css"

const CountUpAnimation = ({ initialValue, targetValue, text }) => {
  const [count, setCount] = useState(initialValue);
  const duration = 4000; // 4 seconds

  useEffect(() => {
    let startValue = initialValue;
    const interval = Math.floor(duration / (targetValue - initialValue));

    const counter = setInterval(() => {
      startValue += 1;
      setCount(startValue);
      if (startValue >= targetValue) {
        clearInterval(counter);
      }
    }, interval);

    return () => {
      clearInterval(counter);
    };
  }, [targetValue, initialValue]);

  return (
    <div className="container">
      <span className="num">{count}+</span>
      <span className="text">{text}</span>
    </div>
  );
};

function Counter (){
  return (
    <div>
      
      <div className="wrapper">
        <CountUpAnimation
          initialValue={0}
          targetValue={15}
          text="Projects"
        />
        <CountUpAnimation
          initialValue={0}
          targetValue={20}
          text="LeetCode"
        />
        <CountUpAnimation
          initialValue={0}
          targetValue={5}
          text="Customers"
        />
      </div>
    </div>
  );
}

export default Counter;